/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Post from '@linc-technologies/linced-common/models/posts/post';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import PostType from '@linc-technologies/linced-common/enums/post-type';

// Proto: posts.Post.
export default class _Post extends Post {
  // Subclasses in linced-learners extend this class with their own types.
  declare [Type]: string;

  @alias('author.id')
  declare author_id: string | null | undefined;

  @alias('person.id')
  declare person_id: string | null | undefined;

  @attr('string', { defaultValue: '' })
  declare raw_assessment_id: string;

  @computed('postType', 'id', 'page.id')
  get url() {
    const id = this.id;
    switch (this.postType) {
      case PostType.POST:
        return `/pages/${this.get('page.id') as string}/posts/${id}`;
      case PostType.STUDENT_NOTICE:
        return `/home/student-notices/${id}`;
      default:
        return `/posts/${id}`;
    }
  }
}
